import api from './api';

export const paymentService = {
  async initializePaystack(orderId) {
    const response = await api.post('/payments/paystack/initialize', { orderId });
    return response.data;
  },

  async verifyPaystack(reference, orderId) {
    const response = await api.post('/payments/paystack/verify', { reference, orderId });
    return response.data;
  },

  async initializePaystackForOrders(orderIds) {
    const response = await api.post('/payments/paystack/initialize-payment', { orderIds });
    return response.data;
  },

  async verifyPaystackForPayment(reference, paymentId) {
    const response = await api.post('/payments/paystack/verify-payment', { reference, paymentId });
    return response.data;
  }
};

export default paymentService;

